import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getRecognition } from 'api/recognitions.service';
import { useToast } from 'hooks/ui';
import { useRecognitionStore } from 'store/recognition';
import { DURATIONS } from 'common/constants';
import { recognitionKeys } from './queryKeys';
import { useRecognitionById } from './useRecognitionGetAllQuery';
import { AllStatuses } from 'interfaces';

export const useRecognitionGetQuery = (id: string) => {
  const draftRecognition = useRecognitionStore((state) => state.draft);
  const toast = useToast();

  const isDraftSaved = draftRecognition.status !== AllStatuses.NOT_SAVED;

  const { data, isLoading, isError, error } = useQuery({
    queryKey: recognitionKeys.recognition(id),
    queryFn: () => getRecognition(id),
    retry: false,
    enabled: Boolean(id),
    refetchInterval: isDraftSaved && DURATIONS.MINUTES_1,
    initialData: useRecognitionById(id),
    refetchIntervalInBackground: isDraftSaved,
  });

  useEffect(() => {
    if (error) {
      toast.error(error.message);
    }
  }, [error, toast]);

  return { isLoading, isError, data };
};
